import React from 'react';
import { Star } from 'lucide-react';

const REVIEWS = [
  { name: 'Ryzan.exe', tag: '@ryzan', stars: 5, text: 'BRXDLE.EXE is insane. No-recoil actually works on every gun and the farming macros save me hours every session in Rust.', product: 'BRXDLE.EXE' },
  { name: 'ShadowKnight92', tag: '@shadow92', stars: 5, text: 'LUCKY BO7 turned my K/D from 1.4 to 3.8 in two weeks. Drop-shot + strafe combo is unreal.', product: 'LUCKY BO7' },
  { name: 'PixelReaper', tag: '@pxlreaper', stars: 5, text: 'Setup was 5 mins. The aim curve on BRXDLE feels natural — not obvious, just clean.', product: 'BRXDLE.EXE' },
  { name: 'FrostbiteRX', tag: '@frostbite', stars: 5, text: 'Best purchase this year. Snake macro on BO7 is the actual meta right now.', product: 'LUCKY BO7' },
  { name: 'NyxaGaming', tag: '@nyxa', stars: 5, text: 'Instant delivery + Discord support is a game changer. Rust profile is dialled straight out of the box.', product: 'BRXDLE.EXE' },
  { name: 'VoltCastellan', tag: '@voltcast', stars: 5, text: 'Hip-assist on BO7 = free lobbies. Worth every dollar and then some.', product: 'LUCKY BO7' },
  { name: 'Kaidenmp4', tag: '@kaidenmp4', stars: 5, text: 'AFK macro alone paid for BRXDLE five times over. Legit.', product: 'BRXDLE.EXE' },
  { name: 'Silv3rHex', tag: '@silv3rhex', stars: 5, text: 'Went 40-3 first game with LUCKY BO7. This is not a drill.', product: 'LUCKY BO7' },
  { name: 'BlazeArkani', tag: '@blaze', stars: 5, text: 'Weapon swap on BRXDLE is smoother than the game itself. Never going back.', product: 'BRXDLE.EXE' },
  { name: 'NovaKamiko', tag: '@novak', stars: 5, text: 'Advanced aim assist on BO7 is subtle but consistent. 10/10 execution.', product: 'LUCKY BO7' },
  { name: 'CypherLoop', tag: '@cypher', stars: 5, text: 'Advanced tracking on BRXDLE is unreal for group PvP. Updates every patch.', product: 'BRXDLE.EXE' },
  { name: 'RexVega', tag: '@rexvega', stars: 5, text: 'Two weeks in, no issues, no bans, silky smooth. LUCKY BO7 is legit.', product: 'LUCKY BO7' },
];

const AVATAR_STYLES = ['pixel-art', 'adventurer', 'bottts', 'lorelei', 'micah', 'notionists'];

function avatarFor(name, i) {
  const style = AVATAR_STYLES[i % AVATAR_STYLES.length];
  return `https://api.dicebear.com/7.x/${style}/svg?seed=${encodeURIComponent(name)}&backgroundColor=1a1a1a,141414,1e1e1e&radius=50`;
}

function ReviewCard({ r, i }) {
  return (
    <div
      className="glass w-[340px] shrink-0 rounded-2xl p-6 border border-white/[0.06]"
      data-testid={`review-card-${i}`}
    >
      <div className="flex items-center gap-3">
        <img
          src={avatarFor(r.name, i)}
          alt=""
          loading="lazy"
          className="h-11 w-11 rounded-full border border-white/10 bg-black shrink-0"
        />
        <div className="min-w-0">
          <div className="text-white font-semibold text-sm truncate">{r.name}</div>
          <div className="text-white/40 text-xs font-mono truncate">{r.tag}</div>
        </div>
        <div className="ml-auto flex items-center gap-0.5 text-brand shrink-0">
          {Array.from({ length: r.stars }).map((_, k) => (
            <Star key={k} className="h-3.5 w-3.5 fill-current" />
          ))}
        </div>
      </div>
      <p className="mt-4 text-white/80 text-sm leading-relaxed">&ldquo;{r.text}&rdquo;</p>
      <div className="mt-4 inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-brand font-mono px-2 py-1 rounded-full bg-brand/10 border border-brand/20">
        {r.product}
      </div>
    </div>
  );
}

export default function ReviewsMarquee() {
  const rowA = REVIEWS.slice(0, 6);
  const rowB = REVIEWS.slice(6);

  return (
    <section
      className="relative px-0 py-20 md:py-28 overflow-hidden"
      data-testid="reviews-marquee-section"
    >
      <div className="mx-auto max-w-7xl px-6 mb-12">
        <div className="flex items-end justify-between">
          <div>
            <p className="text-brand uppercase tracking-[0.35em] text-xs font-mono mb-3">The Verdict</p>
            <h2 className="font-display font-bold text-4xl md:text-5xl tracking-tight">Trusted by <span className="text-brand">thousands</span>.</h2>
          </div>
          <div className="hidden md:flex items-center gap-2 text-white/60 text-sm">
            <div className="flex items-center gap-0.5 text-brand">
              {Array.from({ length: 5 }).map((_, k) => <Star key={k} className="h-4 w-4 fill-current" />)}
            </div>
            <span className="font-mono">4.9 / 5 · 2,400+ reviews</span>
          </div>
        </div>
      </div>

      <div className="relative">
        {/* fade masks left/right */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 z-10 bg-gradient-to-r from-[#111111] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 z-10 bg-gradient-to-l from-[#111111] to-transparent" />

        <MarqueeRow items={rowA} duration={50} />
        <div className="mt-6" />
        <MarqueeRow items={rowB} duration={65} reverse />
      </div>
    </section>
  );
}

function MarqueeRow({ items, duration = 50, reverse = false }) {
  // duplicate for seamless loop
  const track = [...items, ...items];
  return (
    <div className="overflow-hidden">
      <div
        className="flex gap-6 w-max"
        style={{
          animation: `${reverse ? 'marquee-r' : 'marquee-l'} ${duration}s linear infinite`,
        }}
      >
        {track.map((r, i) => (
          <ReviewCard key={`${r.name}-${i}`} r={r} i={i} />
        ))}
      </div>
    </div>
  );
}
